<template>
  <div class="breadcrumb">
    <span class="cursor-pointer text-[#666]" @click="toPre">返回</span>
    <i class="el-icon-arrow-right text-[#666]"></i>
    <span class="text-[#333] font-[600]">{{ breadTitle }}</span>
  </div>
</template>

<script>
export default {
  name: 'customBreadcrumb',
  props:{
    title:{
      type: String,
      default:''
    }
  },

  computed:{
    breadTitle() {
      return this.title.length > 8 ? this.title.slice(0, 8) + '...' : this.title
    }
  },

  methods: {
    toPre(){
      this.$emit('toPre')
    }
  },
};
</script>

<style lang="less" scoped>
.breadcrumb{
  display: flex;
  gap: 5px;
  align-items: center;
}
</style>
